// src/components/page/OrderDetails.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
import { useAuth } from "../context/AuthContext";
// import { getOrderDetails, cancelOrder } from "../../services/orderService";
import { getOrderDetails,cancelOrder } from "../services/orderService";
// import CancelOrderModal from "../CancelOrderModal";
import CancelOrderModal from "../Components/CancelOrderModal";


const OrderDetails = () => {
  const { user } = useAuth();
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  


useEffect(() => {
  const fetchDetails = async () => {
    try {
      const res = await getOrderDetails(orderId); // orderId value log
      console.log("Fetched order details:", res);
      setOrder(res);
    } catch (error) {
      console.error("Error fetching order details:", error);
    }
      // console.log("Order ID from params:", orderId);
  };

 
}, [orderId]);




  const handleCancelOrder = async (reason) => {
    try {
      await cancelOrder(orderId, user.userId, reason);
      alert("Order cancelled successfully!");
      setOrder((prev) => ({ ...prev, status: "Cancelled", can_be_cancelled: false }));
    } catch (error) {
      console.error("Error cancelling order:", error);
      alert("Failed to cancel order.");
    }
  };

  if (loading) return <p className="text-center">Loading order details...</p>;
  if (!order) return <p className="text-center">Order not found.</p>;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Order Details</h2>
      <p><strong>Order ID:</strong> {order.order_id}</p>
      <p><strong>Status:</strong> {order.status}</p>
      <p><strong>Delivery:</strong> {order.estimated_delivery}</p>
      <p><strong>Address:</strong> {order.shipping_address.full_address}</p>

      <h3 className="text-lg font-semibold mt-4">Products:</h3>
      <ul className="space-y-2">
        {order.products.map((p, i) => (
          <li key={i} className="p-2 border rounded">
            <p>{p.product_name}</p>
            <p>Quantity: {p.quantity}</p>
          </li>
        ))}
      </ul>

      {order.can_be_cancelled && (
        <button
          onClick={() => setShowModal(true)}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Cancel Order
        </button>
      )}

      {showModal && (
        <CancelOrderModal
          onClose={() => setShowModal(false)}
          onConfirm={handleCancelOrder}
        />
      )}
    </div>
  );
};

export default OrderDetails;
